const WHITELISTED_SEARCH_PARAMS = [
  'back',
  'month',
  'date',
  'utm_campaign',
  'utm_source',
  'utm_medium',
  'utm_content',
  'utm_term'
]

export const sanitize = (url) => {
  url = new URL(url)
  const sanitizedURL = new URL(url.pathname, url.origin)

  WHITELISTED_SEARCH_PARAMS.forEach((param) => {
    const val = url.searchParams.get(param)

    if (val) {
      sanitizedURL.searchParams.set(param, val)
    }
  })

  return sanitizedURL.toString()
}
